import React, { useEffect, useState } from "react";
import axios from "axios";
import { CreditCard } from "lucide-react";
import "../Styling/Expenses.css";
import { useAuth } from "../Context/AuthContext";
import { Base_URL } from "../url";
import ExpenseModal from "./ExpensesModal";

const Expenses = () => {
  const { user } = useAuth();
  const USER_ID = user?.userId;

  const [allExpenses, setAllExpenses] = useState([]);
  const [currentMonthExpenses, setCurrentMonthExpenses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const API_URL = `${Base_URL}/ExpensesDetails/GetDataUserId?UserId=${USER_ID}`;

  const mapApprovalStatus = (s) =>
    s === "A" ? "Approved" : s === "W" ? "Pending" : "Rejected";

  const mapPaidStatus = (p) => (p ? "Paid" : "Unpaid");

  // ✅ SAFE DATE PARSER
  const parseDate = (value) => {
    if (!value) return null;
    const d = new Date(value);
    return isNaN(d) ? null : d;
  };

  useEffect(() => {
    if (!USER_ID) return;
  
    const fetchExpenses = async () => {
      try {
        const res = await axios.get(API_URL, {
          params: { UserId: USER_ID },
        });
  
        const apiArray = res?.data?.data || [];
  
        // 🔥 CRITICAL FIX: detect correct expense object
        const formatted = apiArray.map((item) => {
          const e =
            item.expenses ||   // if nested
            item.expense ||    // if singular
            item;              // if flat object
  
          return {
            description: e.descriptionNotes || "-",
            amount: Number(e.amountSpent) || 0,
            currency: e.currency || "INR",
            approvalStatus:
              e.approvalStatus === "A"
                ? "Approved"
                : e.approvalStatus === "W"
                ? "Pending"
                : "Rejected",
            paidStatus: e.paidStatus ? "Paid" : "Unpaid",
            date:
              e.expenseDate ||
              e.createdDate ||
              e.createdOn ||
              null,
          };
        });
  
        setAllExpenses(formatted);
  
        // 🔥 ALWAYS SHOW SOMETHING
        const recentThree = formatted.slice(-3).reverse();
        setCurrentMonthExpenses(recentThree);
      } catch (err) {
        console.error("Expense fetch failed", err);
        setAllExpenses([]);
        setCurrentMonthExpenses([]);
      } finally {
        setLoading(false);
      }
    };
  
    fetchExpenses();
  }, [USER_ID]);
  

  const totalAmount = currentMonthExpenses.reduce(
    (sum, e) => sum + e.amount,
    0
  );

  if (loading) {
    return (
      <div className="expenses-card finance">
        <p style={{ fontSize: "12px", textAlign: "center" }}>
          Loading expenses...
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="expenses-card compact">
        <div className="expenses-header compact">
          <div className="expenses-icon small">
            <CreditCard size={18} />
          </div>
          <h4>Monthly Expenses</h4>
          
          <button
            className="view-all-btn"
            onClick={() => setShowModal(true)}
          >
            View All
          </button>
        </div>

        <div className="expenses-summary">
          <span>This Month</span>
          <strong>₹{totalAmount.toLocaleString()}</strong>
        </div>

        <div className="expenses-list">
          {currentMonthExpenses.length === 0 && (
            <p style={{ fontSize: "11px", textAlign: "center" }}>
              No expenses found
            </p>
          )}

          {currentMonthExpenses.map((exp, i) => (
            <div key={i} className="expense-item">
              <div className="expense-top">
                <span className="expense-description">
                  {exp.description}
                </span>
                <span className="expense-amount">
                  ₹{exp.amount.toLocaleString()}
                </span>
              </div>

              <div className="expense-meta">
                <span
                  className={`status approval ${exp.approvalStatus.toLowerCase()}`}
                >
                  {exp.approvalStatus}
                </span>
                <span
                  className={`status payment ${exp.paidStatus.toLowerCase()}`}
                >
                  {exp.paidStatus}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <ExpenseModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        expenses={allExpenses}
      />
    </>
  );
};

export default Expenses;
